/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_End_Tc_HelpInputs */

const en_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When a new event is inserted, the end timecode of the previous event will be set based on the video timecode.`)
};

const fr_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lors de l'insertion d'un nouvel événement, le code temporel de fin de l'événement précédent est défini à partir du timecode vidéo.`)
};

const de_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ein neues Ereignis eingefügt wird, wird der Endzeitcode des vorherigen Ereignisses anhand des Videozeitcodes festgelegt.`)
};

const it_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando viene inserito un nuovo evento, il timecode finale dell'evento precedente verrà impostato in base al timecode video.`)
};

const ru_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При добавлении нового события временной код окончания предыдущего события будет установлен на основе временного кода видео.`)
};

const es_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando se inserta un nuevo evento, el código de tiempo final del evento anterior se establecerá en función del código de tiempo del vídeo.`)
};

const zh_cn2_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当插入新事件时，将根据视频时间码设置前一个事件的结束时间码。`)
};

const ja_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントが挿入されると、前のイベントの終了タイムコードはビデオタイムコードに基づいて設定されます。`)
};

const hi_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब कोई नया इवेंट डाला जाता है, तो पिछले इवेंट का समाप्ति टाइमकोड वीडियो टाइमकोड के आधार पर सेट किया जाएगा।`)
};

const pt_pt2_options_editor_insert_end_tc_help = /** @type {(inputs: Options_Editor_Insert_End_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando um novo evento é inserido, o código de tempo final do evento anterior será definido com base no código de tempo do vídeo.`)
};

/**
* | output |
* | --- |
* | "When a new event is inserted, the end timecode of the previous event will be set based on the video timecode." |
*
* @param {Options_Editor_Insert_End_Tc_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_end_tc_help = /** @type {((inputs?: Options_Editor_Insert_End_Tc_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_End_Tc_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_insert_end_tc_help(inputs)
	if (locale === "de") return de_options_editor_insert_end_tc_help(inputs)
	if (locale === "it") return it_options_editor_insert_end_tc_help(inputs)
	if (locale === "ru") return ru_options_editor_insert_end_tc_help(inputs)
	if (locale === "es") return es_options_editor_insert_end_tc_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_insert_end_tc_help(inputs)
	if (locale === "ja") return ja_options_editor_insert_end_tc_help(inputs)
	if (locale === "hi") return hi_options_editor_insert_end_tc_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_insert_end_tc_help(inputs)
	return en_options_editor_insert_end_tc_help(inputs)
});